/* eslint-disable react/require-default-props */
import { Button, LoadingIndicator } from '@commenda/kakashi';
import React from 'react';

interface SecondaryButtonProps {
  children?: React.ReactNode;
  props?: any;
  additionalStyles?: string;
  type?: 'button' | 'submit';
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  spinnerSize?: 'sm' | 'lg';
  isLoading?: boolean;
}

const SecondaryButton = ({
  children,
  type,
  additionalStyles,
  onClick,
  isLoading,
  spinnerSize,
  disabled,
  ...props
}: SecondaryButtonProps) => {
  return (
    <Button
      type={type === 'submit' ? 'submit' : 'button'}
      {...props}
      size="sm"
      disabled={disabled}
      onClick={onClick}
    >
      {isLoading ? <LoadingIndicator size={16} /> : children}
    </Button>
  );
};

SecondaryButton.defaultProps = {
  children: undefined,
  props: undefined,
  type: undefined,
  onClick: undefined,
  additionalStyles: undefined,
};

export default SecondaryButton;
